import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkHistoryBaseComponent } from './e5core-ui-work-history-base';

@Component({
  selector: 'e5core-ui-work-history-box',
  templateUrl: './e5core-ui-work-history-box.component.html',
  styleUrls: ['./e5core-ui-work-history-box.component.css']
})
export class E5coreUiWorkHistoryBoxComponent extends E5coreUiWorkHistoryBaseComponent {

}
